import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]
  static values = { speed: { type: Number, default: 0.5 } }

  connect() {
    this.list = this.listTarget
    this.isPaused = false

    this.boundPause = this.pause.bind(this)
    this.boundResume = this.resume.bind(this)

    this.element.addEventListener("mouseenter", this.boundPause)
    this.element.addEventListener("mouseleave", this.boundResume)

    // We need to wait for images to load and for the browser to paint
    // before we can accurately calculate widths.
    this.animationFrame = requestAnimationFrame(() => {
      this.originalContentWidth = this.list.scrollWidth
      if (this.originalContentWidth <= this.list.clientWidth) {
        return // No need to animate if content doesn't overflow
      }

      this.cloneItems()
      this.animate()
    })
  }

  disconnect() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
    this.element.removeEventListener("mouseenter", this.boundPause)
    this.element.removeEventListener("mouseleave", this.boundResume)
  }

  cloneItems() {
    // The list contains a single wrapper div, we need to clone its children.
    const itemWrapper = this.list.children[0]
    if (!itemWrapper) return

    const itemsToClone = Array.from(itemWrapper.children)
    itemsToClone.forEach(item => {
      const clone = item.cloneNode(true)
      itemWrapper.appendChild(clone)
    })
  }

  animate() {
    const speed = this.speedValue
    let position = 0

    const step = () => {
      if (!this.isPaused) {
        position -= speed
        this.list.style.transform = `translateX(${position}px)`

        // When the first half of the content has scrolled out of view, reset.
        if (this.originalContentWidth > 0 && Math.abs(position) >= this.originalContentWidth) {
          position = 0
        }
      }

      this.animationFrame = requestAnimationFrame(step)
    }

    this.animationFrame = requestAnimationFrame(step)
  }

  pause() {
    this.isPaused = true
  }

  resume() {
    this.isPaused = false
  }
}
